import { useMemo } from "react";
import { MAX_COMPANY_NAME } from "../constants";
import { Rule } from "antd/es/form";

export const useCompanyNameRules = () => {
  const rules: Rule[] = useMemo(
    () => [
      {
        max: 150,
        message: MAX_COMPANY_NAME,
        validateTrigger: "onSubmit",
      },
      {
        required: true,
        validateTrigger: "onSubmit",
      },
    ],
    []
  );

  return { rules };
};
